import React, { createContext, useContext } from 'react';
import { useAuthzStrategy, type PDPStrategy } from './authz-strategy';

const AuthZContext = createContext<PDPStrategy | null>(null);

export function AuthZProvider({ children }: { children: React.ReactNode }) {
  const strategy = useAuthzStrategy();
  return (
    <AuthZContext.Provider value={strategy}>{children}</AuthZContext.Provider>
  );
}

export function useAuthZ() {
  const ctx = useContext(AuthZContext);
  if (!ctx) throw new Error('useAuthZ must be used within AuthZProvider');
  return ctx;
}

/**
 * Like {@link useAuthZ} but returns `null` instead of throwing when
 * no provider is in scope. For consumers that need the PDP only on
 * specific code paths (e.g. Guide Me's `requires permission:` prefetch
 * that runs only for tours which declare gating clauses), this avoids
 * forcing every render site below them to be wrapped in
 * AuthZProvider.
 */
export function useOptionalAuthZ(): PDPStrategy | null {
  return useContext(AuthZContext);
}


